"use client";

import React from "react";
import * as S from "./styles";

type ColProps = {
  children: React.ReactNode;
  columns: number; // Define the number of columns
  className?: string;
};

const Col: React.FC<ColProps> = ({ children, columns, className }) => {
  return (
    <S.Col columns={columns} className={className}>
      {children}
    </S.Col>
  );
};

export default Col;
